module.exports = __webpack_public_path__ + "img/callCenterWoman.ec80365.webp";